import { ROUTES, SITE_ORIGIN } from '@/navigation/constants'

export const SAMUEL_IMAGE = '/asesoria/hero.jpg'
export const JAVI_IMAGE = '/asesoria/javi.jpg'
export const OG_IMAGE = `${SITE_ORIGIN}${SAMUEL_IMAGE}`
export const ACOMPANAMIENTO_URL = `${SITE_ORIGIN}${ROUTES.ponloEnOrden}?ref=asesoria`
export const LANDING_PAGE = 'asesoria' as const

export const PROBLEM_ROLES = ['cocineros', 'panaderos', 'pasteleros', 'hosteleros'] as const
export const ROLE_ROTATE_MS = 2600

export const MONTHLY_PRICE_EUR = 1500
export const ANNUAL_PRICE_EUR = 14000
export const ANNUAL_SAVE_PCT = Math.round((1 - ANNUAL_PRICE_EUR / (MONTHLY_PRICE_EUR * 12)) * 100)

export const formatPriceEur = (value: number) => `${value.toLocaleString('es-ES')} €`

export const IN_HOUSE_ADVISOR_MONTHLY_COST_EUR = 4500
export const IN_HOUSE_ADMIN_MONTHLY_COST_EUR = 1100

export const PRICING_INCLUDES = [
    'Facturas y ventas preparadas para tu gestoría el día 1 de cada mes',
    'Reclamamos a tus proveedores las facturas que falten',
    'Negociamos con cualquiera de tus proveedores, con precios especiales',
    'App Tipi, red de contactos del sector y búsqueda de financiación para nuevos proyectos',
] as const

export const WHAT_WE_DO = [
    {
        title: 'Tus números, siempre al día',
        tone: 'positive',
        items: [
            'Cuadramos la caja: comprobamos que lo que marca el TPV es lo que entra en el banco y en efectivo.',
            'Controlamos las compras: revisamos que llegan todos los albaranes y que las facturas cuadran con ellos.',
            'Preparamos todas tus facturas y ventas, y reclamamos a tus proveedores las que falten o estén mal.',
            'Tu gestoría tiene toda la información el día 1 de cada mes: sin excusas ni retrasos.',
            'Tenemos tu TPV al día: damos de alta productos y cambiamos precios cuando hace falta.',
        ],
    },
    {
        title: 'Criterio de hostelero',
        tone: 'positive',
        items: [
            'Te decimos qué productos dan dinero y cuáles te cuestan dinero, en cada local.',
            'Miramos si los horarios y las personas encajan con lo que vendes.',
            'Te preparamos lo que pagas y lo que deberías pagar a cada proveedor. Llamas tú o llamamos nosotros.',
            'Alguien con criterio vigila tu negocio contigo. Cuando un coste se dispara no te decimos “arréglalo”: te decimos qué haría alguien del sector en tu lugar.',
        ],
    },
    {
        title: 'Lo que no hacemos',
        tone: 'limit',
        items: [
            'No presentamos impuestos ni llevamos la parte laboral, salvo que contrates también nuestra gestoría.',
            'Si tu gestoría no te convence, tenemos una propia que se cotiza aparte.',
            'No formamos a tu equipo ni a tu jefe de cocina, ni gestionamos la cocina o la sala.',
        ],
    },
] as const

export const HOW_WE_WORK = [
    {
        title: 'Foto de partida y visita presencial',
        body: 'Revisamos todo el negocio en unos 15 días desde que nos das los datos y vamos a tu local. Esa cifra sirve para medir cuánto mejoras.',
    },
    {
        title: 'Poner orden',
        body: 'Conectamos tu TPV, tu banco (solo para ver movimientos) y tu correo de facturas con Tipi, para ver lo que vendes, lo que pagas y lo que te facturan sin pedírtelo cada vez.',
    },
    {
        title: 'Plan de acción',
        body: 'Qué cambiar, en qué orden y cuánto vale cada cambio.',
    },
    {
        title: 'Reunión semanal de una hora',
        body: 'Cómo vas y qué cambiar. Aplicas las medidas esa misma semana y en la siguiente reunión vemos cómo han ido. Cierre de números cada mes y visita presencial cada trimestre.',
    },
    {
        title: 'Acompañamiento en cualquier decisión',
        body: 'Precios, proveedores, equipo o un local nuevo: lo decidimos con números delante.',
    },
] as const

export type BillingCycle = 'monthly' | 'annual'

/** Tipi food-cost brand tokens — same family as the main landing. */
export const FLAME = 'text-[#F4502A]'
export const FLAME_BG = 'bg-[#D13D1A] hover:bg-[#C03618]'
export const INK = 'text-[#17130E]'
export const MUTED = 'text-[#5C5548]'
export const SURFACE_DARK = 'bg-[#241C16]'
export const SURFACE_DARK_UP = 'bg-[#2F261F]'
export const GREEN = 'text-[#2F9B63]'
export const FOCUS = 'focus-visible:outline-none focus-visible:shadow-[0_0_0_2px_#F5EEE4,0_0_0_4px_#E54728]'
export const FOCUS_ON_DARK = 'focus-visible:outline-none focus-visible:shadow-[0_0_0_2px_#17130E,0_0_0_4px_#E54728]'

export const FORM_FIELD_CLASS =
    'h-12 rounded-field border-[#3A312A] bg-[#17130E] px-3.5 text-[15px] text-[#F5EEE4] placeholder:text-[#A89F90] focus-visible:border-[#F4502A]'

export const PRIMARY_CTA_LABEL = 'Quiero que me llaméis'

export function scrollToId(id: string) {
    const el = document.getElementById(id)
    el?.scrollIntoView({ behavior: 'smooth', block: 'start' })
}
